// src/components/Navbar.js
import React, { Component, useState, useEffect, useContext } from "react";
import { FaArrowCircleLeft, FaArrowCircleRight } from 'react-icons/fa'; // Import biểu tượng từ React Icons
import { Cookies } from '../../shared/cookies.js';
import {
    FaYoutube,
    FaTiktok,
    FaTelegramPlane,
    FaFacebook,
    FaDiscord
} from 'react-icons/fa';
import axios from "axios";
import MenuList from "./sidebar_logic.jsx";
import { useDispatch, useSelector } from "react-redux";
import { update_latest_version } from "../../order/orders/actions.js";
import { writeSidebarCollapsed } from "../../shared/sidebar_state.js";
import { isLocalHost } from "../../shared/host_utils.js";

const time_update = 6 * 60 * 60 * 1000; // 6 tiếng
const socialLinks = [
    {
        href: 'https://www.youtube.com/@hust_media',
        iconType: FaYoutube,
        ariaLabel: 'YouTube',
        colorClass: 'text-red-600'
    },
    {
        href: 'https://www.tiktok.com/@rangthotv',
        iconType: FaTiktok,
        ariaLabel: 'TikTok',
        colorClass: 'text-black'
    },
    {
        href: 'https://t.me/freefltiktok',
        iconType: FaTelegramPlane,
        ariaLabel: 'Telegram',
        colorClass: 'text-blue-400'
    },
    {
        href: 'https://discord.gg/FQzpwfhqQv',
        iconType: FaDiscord,
        ariaLabel: 'Discord',
        colorClass: 'text-indigo-600'
    },
    {
        href: 'https://www.facebook.com/hustmedia',
        iconType: FaFacebook,
        ariaLabel: 'Facebook',
        colorClass: 'text-blue-700'
    }
];

const Navbar = ({ isOpen, setIsOpen, isCollapsed, setIsCollapsed, apikeyExists, switch_router, type_user, idExist, set_open_button_support }) => {
    const dispatch = useDispatch();
    const latest_version = useSelector(state => state.latest_version);
    const national_market = Cookies.get('national_market') || 'vi';
    const hostname = window.location.hostname;
    const displayHostname = hostname.includes("tecom.pro") ? "hust.media" : hostname;
    const getMainDomain = () => {
        const hostname = window.location.hostname;
        const parts = hostname.split('.');
        // Nếu có nhiều hơn 2 phần, lấy phần thứ hai từ cuối, ngược lại lấy phần đầu tiên
        return parts.length > 2 ? parts[parts.length - 2] : parts[0];
    };
    const set_latest_version = (value) => {
        dispatch(update_latest_version(value));
    };

    const [sidebar_menu, set_sidebar_menu] = useState([{ label: "Loading data ...", route: "/reactapp?app=showadview", iconType: "SlHome", onlyAuth: "0" }]);
    const myCookieValue = Cookies.get('apikey');
    const currentDomain = window.location.hostname;
    const main_domain = !isLocalHost(window.location.hostname)
        ? (Cookies.get("main_domain") || getMainDomain() || "hust")
        : (Cookies.get("main_domain") || "hust");

    const json_data = {
        apikey: myCookieValue,
        main_domain: main_domain,
        national_market: national_market
    };

    const withEnglishFallback = (labelValue, targetLang) => {
        if (!labelValue || typeof labelValue !== 'object' || Array.isArray(labelValue)) {
            return labelValue;
        }

        const englishLabel = typeof labelValue.en === 'string' ? labelValue.en.trim() : '';
        if (!englishLabel) return labelValue;

        const targetLabel = typeof labelValue[targetLang] === 'string' ? labelValue[targetLang].trim() : '';
        if (targetLabel) return labelValue;

        return {
            ...labelValue,
            [targetLang]: englishLabel,
        };
    };

    const normalizeMenuLanguage = (menu, targetLang) => {
        if (!Array.isArray(menu)) return [];

        return menu.map((item) => {
            const nextItem = {
                ...item,
                label: withEnglishFallback(item?.label, targetLang),
            };

            if (Array.isArray(item?.data)) {
                nextItem.data = normalizeMenuLanguage(item.data, targetLang);
            }

            return nextItem;
        });
    };

    const api_sidebar_menu = async () => {
        try {
            const { data } = await axios.post(
                'https://node_js.hust.media/community/sidebar_menu',
                json_data,
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    maxBodyLength: Infinity,
                }
            );
            const menu = normalizeMenuLanguage(data.api_results.sidebar_menu, national_market);
            const latest_version = data.api_results.latest_version;

            const store = {
                timestamp: Date.now(),
                menu,
                payload: json_data,
            };
            localStorage.setItem('sidebar_menu_test', JSON.stringify(store));
            set_sidebar_menu(menu);
            const expirationDate = new Date(Date.now() + time_update);
            Cookies.set('latest_version', latest_version, { expires: expirationDate });
            set_latest_version(latest_version);

        } catch (error) {
            console.error('api_sidebar_menu error:', error);
        }
    };

    useEffect(() => {
        const cachedLatestVersion = Cookies.get('latest_version');
        if (cachedLatestVersion) {
            set_latest_version(cachedLatestVersion);
        }

        const raw = localStorage.getItem('sidebar_menu_test');
        const currentPayload = JSON.stringify(json_data);

        if (raw && !isLocalHost(currentDomain)) {
            try {
                const { timestamp, menu, payload } = JSON.parse(raw);
                const age = Date.now() - timestamp;

                if (
                    age < time_update &&
                    Array.isArray(menu) &&
                    menu.length > 0 &&
                    JSON.stringify(payload) === currentPayload
                ) {
                    // Cache còn hạn và payload không đổi
                    set_sidebar_menu(normalizeMenuLanguage(menu, national_market));
                } else {
                    // Cache hết hạn hoặc payload đã thay đổi
                    localStorage.removeItem('sidebar_menu_test');
                    api_sidebar_menu();
                }
            } catch {
                localStorage.removeItem('sidebar_menu_test');
                api_sidebar_menu();
            }
        } else {
            // Chưa có cache hoặc đang ở localhost → luôn fetch mới
            api_sidebar_menu();
        }
    }, []);  // logic cũ: dependencies rỗng, không thay đổi  


    return (
        <>
            <nav
                style={{
                    zIndex: isOpen ? 1050 : 'auto',
                    ...(isCollapsed
                        ? {
                            width: '72px',
                            minWidth: '72px',
                            maxWidth: '72px',
                            paddingLeft: '8px',
                            paddingRight: '8px',
                        }
                        : {}),
                }}
                className={`
                antialiased
                text-slate-900
                flex flex-col
                h-full
                overflow-x-hidden
                overflow-y-auto
                bg-gradient-to-r from-indigo-100 via-purple-200 to-pink-200
                px-4 py-4 fixed top-0 left-0
                w-[75vw] min-w-[240px] max-w-[320px]
                ${isCollapsed ? 'w-[72px] min-w-[72px] max-w-[72px] !px-2 md:w-[72px] md:min-w-[72px] md:max-w-[72px] md:!px-2' : 'md:w-[280px] md:min-w-[280px] md:max-w-[280px]'}
                transform transition-transform duration-300 ease-in-out
                ${isOpen ? 'translate-x-0' : '-translate-x-full'} md:translate-x-0
            `}
            >
                <>
                    {(isOpen || window.innerWidth >= 320) && (
                        <>
                            {/* Header */}
                            <div className={`${isCollapsed ? 'justify-center' : 'justify-between'} flex items-center mb-4`}>
                                <div className={`${isCollapsed ? 'hidden' : ''} text-purple-400 font-bold`} style={{ fontSize: "20px" }}>
                                    {displayHostname}
                                </div>
                                <button
                                    onClick={() => {
                                        if (window.matchMedia('(min-width: 768px)').matches) {
                                            const nextCollapsed = !isCollapsed;
                                            setIsCollapsed(nextCollapsed);
                                            writeSidebarCollapsed(nextCollapsed);
                                        } else {
                                            setIsOpen(!isOpen);
                                        }
                                    }}
                                    className="flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center text-white transition-colors hover:text-pink-200"
                                    aria-label={isCollapsed ? 'Expand menu' : 'Collapse menu'}
                                >
                                    {isCollapsed ? <FaArrowCircleRight size={24} /> : <FaArrowCircleLeft size={24} />}
                                </button>
                            </div>

                            {/* Menu Buttons */}
                            <div
                                className="flex w-full self-stretch flex-col border-t-2 border-b-2 border-pink-400"
                                style={{
                                    width: isCollapsed ? '56px' : '100%',
                                    alignSelf: 'center',
                                    flexShrink: 0,
                                }}
                            >
                                <MenuList items={sidebar_menu} switch_router={switch_router} national_market={national_market} isCollapsed={isCollapsed} />
                            </div>

                            {/* Social Footer */}
                            {latest_version == 1 && (
                                <div className="mt-auto pt-2 mb-0 flex justify-around">
                                    {socialLinks.map(({ href, iconType: Icon, ariaLabel, colorClass }) => (
                                        <a
                                            key={ariaLabel}
                                            href={href}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            aria-label={ariaLabel}
                                            className={`hover:opacity-75 transition-opacity ${colorClass}`}
                                        >
                                            <Icon className="h-5 w-5" />
                                        </a>
                                    ))}
                                </div>
                            )}
                        </>
                    )}
                </>

            </nav>
            {isOpen && (
                <div
                    className="fixed inset-0 bg-indigo-600 bg-opacity-20 z-50 md:hidden" // Giảm độ mờ nhạt xuống 20%
                    onClick={() => setIsOpen(false)}
                ></div>
            )}
        </>
    );
};

export default Navbar;
